module.exports = __webpack_public_path__ + "img/0-50.416b4e0f.jpg";